import EFTime from '@/components/UI/svg/dg200/Icon/EFTime';
import EFEnv from '@/components/UI/svg/dg200/Icon/EFEnv';
import EFFuel from '@/components/UI/svg/dg200/Icon/EFFuel';
import EFNoise from '@/components/UI/svg/dg200/Icon/EFNoise';
import EFTimeH5 from '@/components/UI/svg/dg200/Icon/EFTimeH5';
import EFFuelH5 from '@/components/UI/svg/dg200/Icon/EFFuelH5';
import EFEnvH5 from '@/components/UI/svg/dg200/Icon/EFEnvH5';
import EFNoiseH5 from '@/components/UI/svg/dg200/Icon/EFNoiseH5';
import { useGlobal } from '@/utils/useGlobal';
import { TweenMax } from 'gsap';
import css from './index.module.scss';

export default function TextIconF() {
    const { useLang, isMobile, useEffect } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');
    const icons = [
        { icon: isMobile ? <EFTimeH5 /> : <EFTime />, text: t('dg200.textIconF_icon1_text') },
        { icon: isMobile ? <EFFuelH5 /> : <EFFuel />, text: t('dg200.textIconF_icon2_text') },
        { icon: isMobile ? <EFEnvH5 /> : <EFEnv />, text: t('dg200.textIconF_icon3_text') },
        { icon: isMobile ? <EFNoiseH5 /> : <EFNoise />, text: t('dg200.textIconF_icon4_text') },
    ];

    let controller: any;
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    const fadeInOut = (el: any) => {
        const targetEl = `.dg200 .textIconF ${el}`;
        const titleEl = document.querySelector(targetEl) as HTMLElement;
        const titleH = titleEl?.offsetHeight || 100;
        const scene1 = new ScrollMagic.Scene({
            triggerElement: targetEl,
            offset: 0,
            triggerHook: 1,
            duration: titleH,
        });
        const tween1 = TweenMax.fromTo(
            targetEl,
            0.5,
            {
                opacity: 0,
            },
            {
                opacity: 0,
            },
        );
        scene1.setTween(tween1);
        controller.addScene(scene1);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: targetEl,
            offset: titleH,
            triggerHook: 1,
            duration: titleH,
        });
        const tween2 = TweenMax.fromTo(
            targetEl,
            0.5,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        scene2.setTween(tween2);
        controller.addScene(scene2);

        const scene3 = new ScrollMagic.Scene({
            triggerElement: targetEl,
            offset: -100,
            triggerHook: 0,
            duration: titleH,
        });
        const tween3 = TweenMax.fromTo(
            targetEl,
            0.5,
            {
                opacity: 1,
            },
            {
                opacity: 0,
            },
        );
        scene3.setTween(tween3);
        controller.addScene(scene3);
    };

    useEffect(() => {
        if (!isMobile) {
            fadeInOut('.title');
            fadeInOut('.desc');
            fadeInOut('.icons');
        }
    }, []);

    return (
        <div className={`textIconF ${css.textIconF} ${isMobile ? 'textIconF_h5' : 'textIconF_pc'}`}>
            <div className="box">
                <p className="title">{t('dg200.textIconF_title')}</p>
                <p className="desc">{t('dg200.textIconF_desc')}</p>
                <div className="icons">
                    {icons?.map((icon: any, k: number) => (
                        <div className="iconItem" key={k}>
                            <div className="icon-n">{icon?.icon}</div>
                            <p className="text">{icon?.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
